import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Checkbox } from '@material-ui/core';

const styles = theme => ({});

const AfitdCheckbox = props => {
    const { isHidden, ...otherProps } = props;

    if (isHidden) {
        return null;
    } else {
        return <Checkbox color="secondary" {...otherProps} />;
    }
};

export default withStyles(styles)(AfitdCheckbox);
